import { injectReducer } from '../../store/reducers'
import { isLoggedIn } from 'utils/auth'

export default (store) => ({
  path: 'sales-forecast',
  onEnter: isLoggedIn(store),
  getComponent (nextState, callback) {
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const SalesForecast = require('./containers/SalesForecastsContainer').default
      const {salesForecastsFilterReducer, billForecastsReducer, loadStoreOptionsReducer, loadBillFieldsReducer} = require('./modules/salesForecasts')

      injectReducer(store, {key: 'salesForecastsFilter', reducer: salesForecastsFilterReducer})
      injectReducer(store, {key: 'billForecasts', reducer: billForecastsReducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'billFields', reducer: loadBillFieldsReducer})

      /*  Return getComponent   */
      callback(null, SalesForecast)

      /* Webpack named bundle   */
    }, 'SalesForecastsView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/SalesForecasts/index.js